import React from 'react';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import './DeviceTypeCheckbox.css';

export const DeviceTypeCheckbox = (props) => {
  const { selectedDeviceTypes, localSelectedDevicesDictionary, parent, hasCheckbox, bundlesDictionary } = props;

  const createMemberToBundleIdFinder = (bundles) => {
    let memberToBundleIdDictionary = {};
    bundles &&
      Object.keys(bundles).forEach((bundleId) => {
        let members = bundles[bundleId].members;
        for (let member of members) {
          memberToBundleIdDictionary[member.id] = bundleId;
        }
      });

    return memberToBundleIdDictionary;
  };

  const handleOnChange = (event, deviceType) => {
    let selected = selectedDeviceTypes[deviceType].selected;
    let newSelected = !selected;
    let newSelectedDeviceTypes = JSON.parse(JSON.stringify(selectedDeviceTypes));
    let newLocalSelectedDevicesDictionary = JSON.parse(JSON.stringify(localSelectedDevicesDictionary));
    let memberToBundleIdDictionary = createMemberToBundleIdFinder(bundlesDictionary);
    newSelectedDeviceTypes[deviceType].selected = newSelected;
    Object.keys(newSelectedDeviceTypes[deviceType].deviceIds).forEach((deviceId) => {
      newSelectedDeviceTypes[deviceType].deviceIds[deviceId] = newSelected;
      newLocalSelectedDevicesDictionary[deviceId] = newSelected;

      let bundleId = memberToBundleIdDictionary[deviceId];
      newLocalSelectedDevicesDictionary[bundleId] = newSelected;
    });

    parent.setState({
      selectedDeviceTypes: newSelectedDeviceTypes,
      localSelectedDevicesDictionary: newLocalSelectedDevicesDictionary,
      selectedSWVersionID: null,
      targetSwVersion: null
    });
    event.stopPropagation();
  };

  return (
    <div className="BulkSoftwareDownloadModal_DeviceTypesSelected_Div">
      {selectedDeviceTypes &&
        Object.keys(selectedDeviceTypes).map((deviceType, idx) => {
          let { selected, deviceIds } = selectedDeviceTypes[deviceType];
          let numOfSelectedDevices = 0;
          Object.keys(deviceIds).forEach((deviceId) => {
            if (deviceIds[deviceId] === true) {
              numOfSelectedDevices += 1;
            }
          });

          return (
            <div className="BulkSoftwareDownloadModal_DeviceTypesSelected_Item" key={idx}>
              {hasCheckbox && <Checkbox isChecked={selected} onChange={(event) => handleOnChange(event, deviceType)} />}
              <span className="BulkSoftwareDownloadModal_DeviceTypesSelected_Item_NumOfDevices">
                {numOfSelectedDevices}
              </span>
              <span className="BulkSoftwareDownloadModal_DeviceTypesSelected_Item_Title">{deviceType}</span>
            </div>
          );
        })}
    </div>
  );
};
